import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';  // Import useParams to get the URL params
import axiosInstance from '../axiosConfig';
import './PublicProfile.css';
import profilePicture from '../Assets/Images/avatar.png';

const PublicProfile = () => {
    const { username } = useParams();  // Use useParams to extract the username from the URL
    const [profile, setProfile] = useState(null);
    const [error, setError] = useState("");
    const [message, setMessage] = useState(""); // State for message input
    const [receiverId, setReceiverId] = useState(null); // State for receiverId

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                // Fetch the public profile using the username from the URL
                const response = await axiosInstance.get(`/memberprofile/${username}/`);
                setProfile(response.data);  // Set the profile data
                setReceiverId(response.data.user_id);  // Set the receiver ID
            } catch (err) {
                setError("Failed to load the profile.");
                console.error("Error fetching profile:", err);
            }
        };

        fetchProfile();
    }, [username]);  // Make sure to re-fetch when the username changes

    const handleSendMessage = async () => {
        if (!message.trim()) return;

        try {
            // Send the message with the receiverId and content
            const response = await axiosInstance.post("/chats/send_chat/", {
                receiverId: receiverId,  // Use the dynamically fetched receiverId
                content: message,
            });
            alert('Message sent!');
            setMessage(""); // Reset the message input
        } catch (err) {
            console.error("Error sending message", err);
        }
    };

    // Helper function to format the date as "Nov '24"
    const formatJoinDate = (date) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const newDate = new Date(date);
        const month = monthNames[newDate.getMonth()]; // Get the short month name
        const year = newDate.getFullYear().toString().slice(-2); // Get the last 2 digits of the year
        return `${month} '${year}`;  // Format the date as "Nov '24"
    };

    if (error) return <p className="error-text">{error}</p>;
    if (!profile) return <p>Loading profile...</p>;

    return (
        <div className="public-profile-container">
            {/* Profile Header */}
            <div className="profile-header">
                <img
                    src={profilePicture || "/default-avatar.png"}
                    alt="User Avatar"
                    className="profile-avatar"
                />
                <h2>{profile.username}</h2>
                <p className="member-since">
                    Member since {profile.date_joined ? formatJoinDate(profile.date_joined) : "N/A"}
                    {/* Display formatted date */}
                </p>
            </div>

            {/* About Section (Commented Out) */}
            {/* <div className="profile-bio">
                <h3>About Me</h3>
                <p>{profile.bio || "This user hasn't added a bio yet."}</p>
            </div> */}

            {/* Send Message Section */}
            <div className="send-message">
                <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type your message..."
                    rows="4"
                />
                <button onClick={handleSendMessage}>Send Message</button>
            </div>

            {/* Recent Activity Section (Commented Out) */}
            {/* <div className="recent-activity">
                <h3>Recent Activity</h3>
                {profile.recentPosts && profile.recentPosts.length > 0 ? (
                    profile.recentPosts.map((post) => (
                        <div key={post.id} className="user-post">
                            <p className="post-title">{post.title}</p>
                            <p className="post-date">{post.date}</p>
                            <a
                                href={`/post/${post.id}`}
                                className="view-post-link"
                            >
                                View Post
                            </a>
                        </div>
                    ))
                ) : (
                    <p>No recent activity.</p>
                )}
            </div> */}
        </div>
    );
};

export default PublicProfile;
